import React from 'react'

export const Servicio = () => {
  return (
    <div className='page'>
      <h1>Servicios</h1>

      <section className='services'>
        <article className='service'>
          <h2>Diseño Web</h2>
          <p>Hago que tu web se vea Bonita</p>
        </article>
        <article className='service'>
          <h2>Desarrollo Web</h2>
          <p>Creo tu web desde cero</p>
        </article>
        <article className='service'>
          <h2>Posicionamiento Web</h2>
          <p>Hago que tu web aparezca en los buscadores y que la gente la vea</p>
        </article>
        <article className='service'>
          <h2>Administración de projectos</h2>
          <p>Gestión de proyectos medianos y grandes bajo la metodología Agile (reuniones diarias de seguimiento, reuniones retrospectivas, planificación de sprints, eliminación de obstáculos y gestión del backlog).</p>
        </article>
      </section>
    </div>
  )
}
